<script setup>
import Section from "../internal/Section.vue";
import EditableField from "../fields/EditableField.vue";
import ReadonlyField from "../fields/ReadonlyField.vue";

defineProps({
  data: { type: Object, required: true },
  editMode: { type: Boolean, default: false },
  isOwn: { type: Boolean, default: false },
});

const emit = defineEmits(["update"]);
function setField(key, value) {
  emit("update", key, value);
}
</script>

<template>
  <Section icon="sli-case" :title="$t('Нотариальная палата')">
    <div class="grid grid-cols-2 gap-x-5 gap-y-3.5 max-sm:grid-cols-1">
      <template v-if="editMode">
        <EditableField
          :label="$t('Дата вступления в палату')"
          type="date"
          :model-value="data.chamber_join_date"
          @update:model-value="setField('chamber_join_date', $event)"
        />
        <EditableField
          :label="$t('Рабочий телефон')"
          :model-value="data.work_phone"
          @update:model-value="setField('work_phone', $event)"
        />
        <EditableField
          :label="$t('Дата начала оплаты вступительных платежей')"
          type="date"
          :model-value="data.payment_start_date"
          @update:model-value="setField('payment_start_date', $event)"
        />
        <EditableField
          :label="$t('Дата окончания оплаты вступительных платежей')"
          type="date"
          :model-value="data.payment_end_date"
          @update:model-value="setField('payment_end_date', $event)"
        />
      </template>
      <template v-else>
        <ReadonlyField
          :label="$t('Дата вступления в палату')"
          :value="data.chamber_join_date"
          type="date"
        />
        <ReadonlyField
          :label="$t('Рабочий телефон')"
          :value="data.work_phone"
        />
        <ReadonlyField
          :label="$t('Дата начала оплаты вступительных платежей')"
          :value="data.payment_start_date"
          type="date"
        />
        <ReadonlyField
          :label="$t('Дата окончания оплаты вступительных платежей')"
          :value="data.payment_end_date"
          type="date"
        />
      </template>
    </div>
  </Section>
</template>
